import React, { useState } from "react";
import {
  IonButton,
  IonPopover,
  IonContent,
  IonItem,
  IonList,
  IonListHeader,
  IonPage,
  useIonPopover,
  IonModal,
} from "@ionic/react";

export const DocumentUploadTooltip = ({ userId }: any) => {
  const [showModal, setShowModal] = useState(false);
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const fromNewDocWithCompliance = "subir-nuevo-documento";

  return (
    <>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonList>
          <IonItem
            button
            href={`/app/supervision/colaborador/${fromNewDocWithCompliance}/${userId}`}
          >
            Subir Documento
          </IonItem>
          <IonItem button href={`/app/supervision/colaborador/subir-firma-digital/${userId}`}>
            Subir Documento para firma digital
          </IonItem>
          <IonItem button href={`/app/supervision/colaborador/subir-desde-plantilla/${userId}`}>
            Generar Documento desde plantilla para firma digital
          </IonItem>
        </IonList>
      </IonModal>
      {/* <IonPopover
        cssClass="my-custom-class"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonList>
          <IonItem button href={`/app/supervision/colaborador/${fromNewDocWithCompliance}/${userId}`}>
            Subir Documento
          </IonItem>
          <IonItem button href={`/app/supervision/colaborador/subir-firma-digital/${userId}`}>
            Subir Documento para firma digital
          </IonItem>
          <IonItem button href={`/app/supervision/colaborador/subir-desde-plantilla/${userId}`}>
            Generar Documento desde plantilla para firma digital
          </IonItem>
        </IonList>
      </IonPopover> */}
      <IonButton
        fill="solid"
        expand="block"
        color="secondary"
        size="default"
        onClick={(e: any) => {
          // e.persist();
          // setShowPopover({ showPopover: true, event: e });
          setShowModal(true);
        }}
      >
        Nuevo Documento
      </IonButton>
    </>
  );
};
